<div id="map" style="width: 100%; height: 400px;"></div>
<!-- <div id="street-view"  style="height: 400px; width: 30%;"></div> -->